// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_org_type from "../../../../proto/commonapis/gen/buhta_common_v1_org_type.js";

const include = Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType;

function ofCountry(param) {
  return {
          hd: /* ORG_TYPE_IP */1,
          tl: {
            hd: /* ORG_TYPE_TOO */2,
            tl: {
              hd: /* ORG_TYPE_TDO */3,
              tl: {
                hd: /* ORG_TYPE_PK */4,
                tl: {
                  hd: /* ORG_TYPE_AO */5,
                  tl: {
                    hd: /* ORG_TYPE_OAO */6,
                    tl: {
                      hd: /* ORG_TYPE_ZAO */7,
                      tl: {
                        hd: /* ORG_TYPE_OO */8,
                        tl: {
                          hd: /* ORG_TYPE_GP */9,
                          tl: {
                            hd: /* ORG_TYPE_PERSON */10,
                            tl: {
                              hd: /* ORG_TYPE_OTHER */11,
                              tl: {
                                hd: /* ORG_TYPE_UNSPECIFIED */0,
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function toString(param) {
  switch (param) {
    case /* ORG_TYPE_UNSPECIFIED */0 :
        return "Тип предприятия";
    case /* ORG_TYPE_IP */1 :
        return "Индивидуальный предприниматель";
    case /* ORG_TYPE_TOO */2 :
        return "Товарищество с ограниченной ответственностью";
    case /* ORG_TYPE_TDO */3 :
        return "Товарищество с дополнительной ответственностью";
    case /* ORG_TYPE_PK */4 :
        return "Частная компания";
    case /* ORG_TYPE_AO */5 :
        return "Акционерное общество";
    case /* ORG_TYPE_OAO */6 :
        return "Открытое акционерное общество";
    case /* ORG_TYPE_ZAO */7 :
        return "Закрытое акционерное общество";
    case /* ORG_TYPE_OO */8 :
        return "Общественное объединение";
    case /* ORG_TYPE_GP */9 :
        return "Государственное предприятие";
    case /* ORG_TYPE_PERSON */10 :
        return "Физическое лицо";
    case /* ORG_TYPE_OTHER */11 :
        return "Иное";
    
  }
}

const Type_name = include.name;

const Type_to_int = include.to_int;

const Type_from_int = include.from_int;

const Type_from_int_exn = include.from_int_exn;

const Type_to_string = include.to_string;

const Type_from_string_exn = include.from_string_exn;

const Type = {
  name: Type_name,
  to_int: Type_to_int,
  from_int: Type_from_int,
  from_int_exn: Type_from_int_exn,
  to_string: Type_to_string,
  from_string_exn: Type_from_string_exn,
  ofCountry: ofCountry,
  toString: toString
};

export {
  Type ,
}
/* Buhta_commonapis__Buhta_common_v1_org_type Not a pure module */
